export const BASE_URL   = process.env.REACT_APP_BASE_URL
export const ROOT_URL   = process.env.REACT_APP_IMAGE_URL
export const BUCKET_URL = process.env.REACT_APP_BUCKET_URL
